module.exports = __webpack_public_path__ + "static/media/csv-file.3dc18979.svg";